import React from 'react';
import { View, Image } from 'react-native';

import { IS_WEB, webOnly } from 'utils/relicVault/webStyle';

/**
 * One relic icon cut out of its sprite sheet.
 *
 * The backend serves each relic a sheet URL and the cell it occupies; the sheet
 * is a grid (3x2 today, but read from the catalog rather than assumed). The
 * whole sheet is an Image inside a clipped box, scaled so one cell fills the
 * box and offset so this relic's cell is the one showing.
 *
 * `locked` draws the uniform white silhouette used for undiscovered relics.
 * `shadow` adds the design's drop shadow (web only).
 */
const RelicSprite = ({
  relic,
  grid,
  size,
  locked = false,
  shadow = 'rgba(0,0,0,0.4)',
  style,
}) => {
  const columns = grid?.columns;
  const rows = grid?.rows;
  if (!relic?.sheetUrl || !columns || !rows) {
    return <View style={[{ width: size, height: size }, style]} />;
  }

  // Web: CSS filters give the exact silhouette + drop shadow from the design.
  // Native: tintColor flattens the icon to white for the silhouette.
  const k = size / 160;
  const imageEffects = locked
    ? IS_WEB
      ? { filter: 'brightness(0) invert(1)', opacity: 0.55 }
      : { tintColor: '#FFFFFF', opacity: 0.55 }
    : webOnly(shadow ? { filter: `drop-shadow(0 ${6 * k}px ${12 * k}px ${shadow})` } : null);

  return (
    <View
      pointerEvents="none"
      style={[{ width: size, height: size, overflow: 'hidden' }, style]}>
      <Image
        source={{ uri: relic.sheetUrl }}
        resizeMode="stretch"
        style={[
          {
            position: 'absolute',
            left: -relic.col * size,
            top: -relic.row * size,
            width: size * columns,
            height: size * rows,
          },
          imageEffects,
        ]}
      />
    </View>
  );
};

export default React.memo(RelicSprite);
